import { render, staticRenderFns } from "./SkupTeme2.vue?vue&type=template&id=1f8df3b3&scoped=true&"
import script from "./SkupTeme2.vue?vue&type=script&lang=js&"
export * from "./SkupTeme2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8df3b3",
  null
  
)

export default component.exports